(() => {
  const sec = document.querySelector('[data-wwc-city-browser]');
  if (!sec || sec.dataset.inited === '1') return;
  sec.dataset.inited = '1';

  const root = sec.querySelector('[data-wwc-scope]');
  const grid = root?.querySelector('[data-grid]');
  if (!root || !grid) return;

  const STR = {
    SHOW_MORE: sec.dataset.showMore || 'Toon meer',
    LEFT: sec.dataset.left || 'over',
    RESET: sec.dataset.reset || 'Reset',
    NO_RESULTS: sec.dataset.noResults || 'Geen resultaten gevonden',
    NO_RESULTS_FILTERS: sec.dataset.noResultsFilters || 'Geen resultaten met deze filters',
    DID_YOU_MEAN: sec.dataset.didYouMean || 'Bedoelde je misschien',
    ALL_COUNTRIES: sec.dataset.allCountries || 'Alle landen',
    ALL_PROVINCES: sec.dataset.allProvinces || 'Alle provincies',
    COUNT_SUFFIX: sec.dataset.countSuffix || 'steden',
    REQUEST: sec.dataset.request || 'Stad aanvragen'
  };

  const LOCALE = sec.dataset.locale || document.documentElement.lang || 'nl';

  const searchInput = root.querySelector('input[type="search"]');
  const clearInputBtn = root.querySelector('.wwc-clear-input');
  const suggestBox = root.querySelector('[data-suggest]');
  const filterBtns = [...root.querySelectorAll('.wwc-btn')];
  const azSelect = root.querySelector('[data-az-select]');
  const countEl = root.querySelector('[data-count]');
  const emptyEl = root.querySelector('[data-empty]');
  const emptyMsgEl = root.querySelector('[data-empty-msg]');
  const nearTitleEl = root.querySelector('[data-near-title]');
  const nearGrid = root.querySelector('[data-near-cards]');
  const prevBtn = root.querySelector('[data-prev]');
  const nextBtn = root.querySelector('[data-next]');
  const countrySel = root.querySelector('[data-facet="country"]');
  const provinceSel = root.querySelector('[data-facet="province"]');
  const sortSel = root.querySelector('[data-sort]');
  const clearBtn = root.querySelector('[data-clear]');
  const moreBtn = root.querySelector('[data-more]');
  const moreWrap = root.querySelector('[data-more-wrap]');

  const debounce = (fn,d=200) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), d);
    };
  };

  const norm = s => (s || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .replace(/['’`]/g,'')
    .trim();

  const stop = new Set([
    'skyline','city','stad','plaats','plek',
    'place','town','village',
    'stadt','ort','dorf',
    'ville','lieu','village'
  ]);

  const cards = [...grid.querySelectorAll('.wwc-card')].map(el => {
    const cityRaw = el.dataset.city || '';

    return {
      el,
      city: norm(cityRaw),
      cityLabel: cityRaw,
      title: el.dataset.title || ('Skyline ' + cityRaw),
      fl: (el.dataset.firstletter || '').toUpperCase(),
      sortname: el.dataset.sortname || el.dataset.city || '',
      country: norm(el.dataset.country || ''),
      countryLabel: el.dataset.countrylabel || '',
      province: norm(el.dataset.province || ''),
      provinceLabel: el.dataset.provincelabel || '',
      url: el.dataset.url || '#',
      img: el.dataset.img || '',
      index: +(el.dataset.index || 0),
      pop: +(el.dataset.pop || 0)
    };
  });

  const alias = new Map([
    ['den haag','den haag'],
    ['the hague','den haag'],
    ['la haye','den haag'],
    ['s-gravenhage','den haag']
  ]);

  const url = new URL(location.href);

  const state = {
    q: norm(url.searchParams.get('q') || ''),
    range: (url.searchParams.get('range') || 'all').toLowerCase(),
    country: norm(url.searchParams.get('land') || ''),
    province: norm(url.searchParams.get('prov') || ''),
    sort: (url.searchParams.get('sort') || 'default')
  };

  const countBy = arr => {
    const m = new Map();
    arr.forEach(v => {
      if (!v) return;
      m.set(v, (m.get(v) || 0) + 1);
    });
    return m;
  };

  const sortCount = m => [...m.entries()].sort((a,b) => {
    return b[1] - a[1] || a[0].localeCompare(b[0], LOCALE);
  });

  const title = s => (s || '')
    .split(/[_-]/g)
    .map(p => p ? p[0].toUpperCase() + p.slice(1) : p)
    .join(' ');

  const populateSelect = (sel, entries, label) => {
    if (!sel) return;

    const keep = sel.value;
    const html = ['<option value="">' + label + '</option>']
      .concat(entries.map(([v,c]) => `<option value="${v}">${title(v)} (${c})</option>`))
      .join('');

    if (sel._lastHTML !== html) {
      sel.innerHTML = html;
      sel._lastHTML = html;
    }

    if (entries.some(([v]) => v === keep)) {
      sel.value = keep;
    } else {
      sel.value = '';
    }
  };

  const getProvinceEntries = () => {
    const pool = state.country
      ? cards.filter(c => c.country === state.country)
      : cards;

    return sortCount(countBy(pool.map(c => c.province)));
  };

  const rebuildProvinceSelect = () => {
    populateSelect(provinceSel, getProvinceEntries(), STR.ALL_PROVINCES);

    if (!state.country) {
      state.province = '';
      if (provinceSel) {
        provinceSel.value = '';
        provinceSel.disabled = true;
      }
      return;
    }

    if (provinceSel) provinceSel.disabled = false;

    const validProvinces = new Set(getProvinceEntries().map(([v]) => v));

    if (state.province && validProvinces.has(state.province)) {
      provinceSel.value = state.province;
    } else {
      state.province = '';
      provinceSel.value = '';
    }
  };

  /* De zoekterm vertraagd naar de adresbalk schrijven.

     Elke `history.replaceState` telt bij GA4, de Meta-pixel en Google Ads als
     paginaweergave. Zonder vertraging is dat er een per toetsaanslag; zo kwam
     deze pagina eerder aan 15.126 "weergaven" die geen bezoeken waren. Nu pas
     900 ms na de laatste aanslag, en alleen als de URL echt verandert. */
  let urlTermTimer = null;

  const syncUrl = (termDirect) => {
    if (!termDirect && state.q) {
      clearTimeout(urlTermTimer);
      urlTermTimer = setTimeout(() => syncUrl(true), 900);
      return;
    }

    const p = new URLSearchParams();

    if (state.q) p.set('q', state.q);
    if (state.range !== 'all') p.set('range', state.range);
    if (state.country) p.set('land', state.country);
    if (state.province) p.set('prov', state.province);
    if (state.sort !== 'default') p.set('sort', state.sort);

    const nieuw = location.pathname + (p.toString() ? ('?' + p.toString()) : '');
    if (nieuw === location.pathname + location.search) return;

    history.replaceState(null, '', nieuw);
  };

  const inRange = (ch,code) => {
    if (code === 'all') return true;

    const m = {
      ac:['A','B','C'],
      df:['D','E','F'],
      gi:['G','H','I'],
      jl:['J','K','L'],
      mo:['M','N','O'],
      pt:['P','Q','R','S','T'],
      uz:['U','V','W','X','Y','Z']
    };

    return (m[code] || []).includes((ch || '').toUpperCase());
  };

  const updateAZCounts = pool => {
    const c = {all:0,ac:0,df:0,gi:0,jl:0,mo:0,pt:0,uz:0};

    pool.forEach(x => {
      c.all++;
      const f = x.fl;

      if ('ABC'.includes(f)) c.ac++;
      else if ('DEF'.includes(f)) c.df++;
      else if ('GHI'.includes(f)) c.gi++;
      else if ('JKL'.includes(f)) c.jl++;
      else if ('MNO'.includes(f)) c.mo++;
      else if ('PQRST'.includes(f)) c.pt++;
      else if ('UVWXYZ'.includes(f)) c.uz++;
    });

    filterBtns.forEach(btn => {
      const code = btn.dataset.range;
      const badge = btn.querySelector('.wwc-az-count');
      if (badge) badge.textContent = '(' + (c[code] ?? c.all) + ')';
    });

    if (azSelect) {
      [...azSelect.options].forEach(o => {
        const code = o.value || 'all';
        const base = o.dataset.label || o.text;
        const cnt = c[code] ?? c.all;
        o.text = `${base} (${cnt})`;
      });
    }
  };

  const PAGE = 40;
  let pageLimit = PAGE;

  const toggleMore = remaining => {
    const show = remaining > 0;

    if (moreBtn) {
      moreBtn.hidden = !show;
      if (show) moreBtn.textContent = `${STR.SHOW_MORE} (${remaining} ${STR.LEFT})`;
    }

    if (moreWrap) moreWrap.classList.toggle('is-hidden', !show);
  };

  const reorder = pool => {
    /* Altijd alfabetisch, op de sorteernaam en niet op de weergavenaam:
       's-Gravendeel hoort bij de G, 's-Hertogenbosch bij de H. De apostrof komt
       in de tekencodering vóór de A en zette die twee anders bovenaan.

       Het sorteerveld is verwijderd omdat "Standaard" en "A-Z" dezelfde volgorde
       gaven; dit is nu de enige volgorde. */
    pool.sort((a, b) => (a.sortname || a.city).localeCompare(b.sortname || b.city, LOCALE));
    if (state.sort === 'alpha_desc') pool.reverse();

    const frag = document.createDocumentFragment();
    pool.forEach(c => frag.appendChild(c.el));
    grid.appendChild(frag);
  };

  /* Meten. Zelfde vorm als de rest van het thema (wwc-ar.js, wwc-cro-ux.js). */
  const meld = (naam, gegevens) => {
    if (!window.dataLayer) return;
    window.dataLayer.push(Object.assign({ event: naam }, gegevens || {}));
  };

  /* Niet bij elke toetsaanslag: anders staat "u", "ut", "utr" als drie
     zoekopdrachten in de rapportage. */
  let meldTimer = null;
  const meldStraks = (naam, gegevens, ms) => {
    clearTimeout(meldTimer);
    meldTimer = setTimeout(() => meld(naam, gegevens), ms || 1200);
  };

  const modeAttr = () => sec.getAttribute('data-layout') || 'auto';

  /* Vier standen: grid, list, slider, auto. `auto` = raster, ook op de telefoon:
     deze pagina draait om het herkennen van een silhouet, en dat kan niet in een
     lijst van 64x44 of achter een swipe. Onder 360px past een raster van twee
     kolommen niet meer, daar valt hij terug op een lijst.

     Het resultaat komt als `data-view` op de sectie; de CSS haakt daarop, zodat
     er niet twee plekken over de weergave beslissen. */
  const huidigeWeergave = () => {
    const m = modeAttr();
    if (m === 'grid' || m === 'list' || m === 'slider') return m;
    return window.innerWidth < 360 ? 'list' : 'grid';
  };

  const zetWeergave = () => sec.setAttribute('data-view', huidigeWeergave());
  zetWeergave();
  window.addEventListener('resize', zetWeergave);

  const isSlider = () => {
    if (huidigeWeergave() !== 'slider') return false;
    const m = modeAttr();
    return m === 'slider' || (m === 'auto' && window.innerWidth < 900);
  };

  const pageStep = () => Math.max((grid.clientWidth || 0) * 0.9, 320);

  const updateArrows = () => {
    if (!prevBtn || !nextBtn) return;

    if (!isSlider()) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    const anyShown = [...grid.querySelectorAll('.wwc-card')]
      .some(el => !el.classList.contains('is-hidden'));

    if (!anyShown) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth - 2);

    prevBtn.disabled = grid.scrollLeft <= 2;
    nextBtn.disabled = grid.scrollLeft >= maxScroll;
  };

  const cleanQ = q => q.split(/\s+/).filter(w => !stop.has(w)).join(' ');
  const starts = (t,q) => t.startsWith(q);

  const levenshtein = (a,b) => {
    const m = [];

    for (let i=0;i<=b.length;i++) m[i] = [i];
    for (let j=0;j<=a.length;j++) m[0][j] = j;

    for (let i=1;i<=b.length;i++) {
      for (let j=1;j<=a.length;j++) {
        m[i][j] = b[i-1] === a[j-1]
          ? m[i-1][j-1]
          : Math.min(m[i-1][j-1]+1, m[i][j-1]+1, m[i-1][j]+1);
      }
    }

    return m[b.length][a.length];
  };

  /* "Bedoelde je" alleen bij een echte verschrijving.

     Hier stond geen ondergrens: de beste drie kwamen er altijd uit, hoe slecht
     ook. "Denekampxyz" leverde Bennekom, Den Haag en Kampen op - drie plaatsen
     die niets met de invoer te maken hebben, gepresenteerd als suggestie.

     Gemeten gelijkenis: Grningen->Groningen 0,89 (typefout), Denekamp->Bennekom
     0,50 (bestaande plaats die we niet hebben), Denekampxyz->Bennekom 0,36. De
     drempel van 0,64 scheidt die drie gevallen, en komt uit dezelfde bron als de
     zoekbalk en de zoekpagina. */
  const DREMPEL = (window.WWCSearchHelpers && window.WWCSearchHelpers.DREMPEL) || 0.64;

  const gelijkenis = (a,b) => {
    const langste = Math.max(norm(a).length, norm(b).length, 1);
    return 1 - (levenshtein(a,b) / langste);
  };

  const fuzzyNearest = (q,list,k=3) => {
    if (!q) return [];

    return list
      .map(c => ({c, s: gelijkenis(c.city, q)}))
      .filter(x => x.s >= DREMPEL)
      .sort((a,b) => b.s - a.s)
      .slice(0,k)
      .map(x => x.c);
  };

  const countryFlag = c => {
    const s = norm(c);

    const map = {
      "nederland":"NL",
      "netherlands":"NL",
      "pays-bas":"NL",
      "niederlande":"NL",
      "belgie":"BE",
      "belgium":"BE",
      "belgique":"BE",
      "belgien":"BE",
      "duitsland":"DE",
      "germany":"DE",
      "deutschland":"DE",
      "allemagne":"DE",
      "frankrijk":"FR",
      "france":"FR",
      "spanje":"ES",
      "spain":"ES",
      "espagne":"ES",
      "spanien":"ES",
      "italie":"IT",
      "italy":"IT",
      "italien":"IT",
      "verenigd koninkrijk":"GB",
      "united kingdom":"GB",
      "royaume-uni":"GB",
      "vereinigtes konigreich":"GB",
      "uk":"GB"
    };

    const code = map[s];
    if (!code) return "";

    return [...code].map(ch => String.fromCodePoint(127397 + ch.charCodeAt())).join("");
  };

  const openSuggest = items => {
    if (!suggestBox) return;

    if (!items.length) {
      suggestBox.classList.remove('is-open');
      suggestBox.innerHTML = '';
      return;
    }

    suggestBox.innerHTML = items.map((it,i) => `
      <div class="wwc-sg-item" role="option" data-url="${it.url}" tabindex="0" aria-selected="${i === 0 ? 'true' : 'false'}">
        ${it.img ? `<img class="wwc-sg-thumb" src="${it.img}" alt="">` : `<div class="wwc-sg-thumb"></div>`}
        <div>
          <div class="wwc-sg-city">${it.cityLabel}</div>
          <div class="wwc-sg-sub">${countryFlag(it.countryLabel)} ${it.countryLabel}${it.provinceLabel ? ' · ' + it.provinceLabel : ''}</div>
        </div>
      </div>
    `).join('');

    suggestBox.classList.add('is-open');

    [...suggestBox.querySelectorAll('.wwc-sg-item')].forEach(el => {
      el.addEventListener('click', () => location.assign(el.dataset.url));
      el.addEventListener('keydown', e => {
        if (e.key === 'Enter') location.assign(el.dataset.url);
      });
    });
  };

  const buildSuggest = q => {
    if (!suggestBox) return;

    if (!q) {
      openSuggest([]);
      return;
    }

    const aliasQ = alias.get(q) || q;
    let cand = cards.filter(c => c.city.includes(aliasQ) || starts(c.city, aliasQ));

    if (!cand.length) cand = fuzzyNearest(q, cards, 6);

    openSuggest(cand.slice(0,6).map(c => ({
      url:c.url,
      img:c.img,
      cityLabel:c.cityLabel,
      countryLabel:c.countryLabel,
      provinceLabel:c.provinceLabel
    })));
  };

  const updateReset = () => {
    const active = !!(state.q || state.country || state.province || state.range !== 'all' || state.sort !== 'default');
    if (clearBtn) clearBtn.classList.toggle('is-visible', active);
  };

  const updateEmpty = matched => {
    if (!emptyEl) return;

    const filtersActive = !!(state.country || state.province || state.range !== 'all');

    emptyMsgEl.textContent = (matched === 0 && filtersActive)
      ? STR.NO_RESULTS_FILTERS
      : STR.NO_RESULTS;

    nearGrid.innerHTML = '';

    let near = [];

    if (matched === 0 && state.q) {
      near = fuzzyNearest(cleanQ(state.q), cards, 3);
    }

    nearTitleEl.textContent = STR.DID_YOU_MEAN;
    nearTitleEl.style.display = near.length ? 'block' : 'none';

    near.forEach(c => {
      nearGrid.insertAdjacentHTML(
        'beforeend',
        `<a class="wwc-near-card" href="${c.url}">${c.img ? `<img src="${c.img}" alt="">` : `<div class="wwc-near-hero">🏙️</div>`}<div>${c.cityLabel}</div></a>`
      );
    });

    /* De aanvraag-tegel stond hier tussen de "bedoelde je"-suggesties.

       Sinds 1 september staat de uitweg als eigen blok in de Liquid, met Jouw
       Plek voorop en de aanvraag ernaast. Deze tegel was daarmee de tweede knop
       met dezelfde functie, tien pixels ernaast - en hij stond tussen plaatsen
       die wél bestaan, waardoor "Stad aanvragen" op een suggestie leek. */

    emptyEl.style.display = matched === 0 ? 'block' : 'none';
  };

  const updateTitles = () => {
    cards.forEach(c => {
      const a = c.el.querySelector('.wwc-titlelink');
      if (a) a.textContent = c.title;
    });
  };

  const apply = () => {
    rebuildProvinceSelect();

    const poolCountry = cards.filter(c =>
      (!state.country || state.country === c.country) &&
      (!state.province || state.province === c.province)
    );

    updateAZCounts(poolCountry);

    const q = cleanQ(state.q);
    let pool = poolCountry.filter(c => inRange(c.fl, state.range));

    if (q) {
      const aliasQ = alias.get(q) || q;
      pool = pool.filter(c => c.city.includes(aliasQ) || c.city.startsWith(aliasQ));
    }

    reorder(pool);

    let matched = 0;
    let visible = 0;

    cards.forEach(c => c.el.classList.add('is-hidden'));

    for (const c of pool) {
      matched++;

      if (visible < pageLimit) {
        c.el.classList.remove('is-hidden');
        visible++;
      }
    }

    if (countEl) countEl.textContent = matched + ' ' + STR.COUNT_SUFFIX;

    /* De reset-knop alleen tonen als er iets te resetten valt; anders staat er
       permanent een knop die niets doet. */
    const resetKnop = root.querySelector('.wwc-clear');
    if (resetKnop && resetKnop.parentElement) {
      const actief = !!(state.country || state.province || (state.range && state.range !== 'all') || (state.q || '').trim());
      resetKnop.parentElement.classList.toggle('heeft-filter', actief);
    }

    updateEmpty(matched);

    const zoekterm = (state.q || '').trim();
    if (zoekterm) {
      meldStraks(matched === 0 ? 'wwc_steden_geen_resultaat' : 'wwc_steden_zoek', {
        zoekterm: zoekterm,
        resultaten: matched,
        weergave: huidigeWeergave()
      });
    }
    toggleMore(Math.max(0, matched - pageLimit));
    syncUrl();
    updateArrows();
    updateTitles();
  };

  /* Klikken, gedelegeerd zodat het ook geldt voor kaarten die pas na "Toon meer"
     of een filterwissel verschijnen. */
  sec.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;

    const kaart = t.closest('[data-city]');
    if (kaart) return meld('wwc_steden_klik', { plaats: kaart.dataset.city, weergave: huidigeWeergave() });

    const uitweg = t.closest('.wwc-cb-uitweg a');
    if (uitweg) return meld('wwc_steden_uitweg', {
      doel: (uitweg.getAttribute('href') || '').indexOf('jouw-plek') > -1 ? 'jouw-plek' : 'aanvraag',
      zoekterm: (state.q || '').trim() || null
    });

    if (t.closest('.wwc-near-card')) meld('wwc_steden_suggestie', { zoekterm: (state.q || '').trim() || null });
  });

  [countrySel, provinceSel].forEach((sel) => {
    sel?.addEventListener('change', () => meld('wwc_steden_filter', {
      soort: sel === countrySel ? 'land' : 'provincie',
      waarde: sel.value || '(alle)'
    }));
  });

  moreBtn?.addEventListener('click', () => {
    meld('wwc_steden_toon_meer', { weergave: huidigeWeergave() });
    pageLimit += PAGE;
    apply();
  });

  prevBtn?.addEventListener('click', () => grid.scrollBy({left:-pageStep(),behavior:'smooth'}));
  nextBtn?.addEventListener('click', () => grid.scrollBy({left:pageStep(),behavior:'smooth'}));

  let tick = false;

  grid.addEventListener('scroll', () => {
    if (tick) return;

    tick = true;

    requestAnimationFrame(() => {
      tick = false;
      updateArrows();
    });
  }, {passive:true});

  window.addEventListener('resize', debounce(updateArrows,150));

  filterBtns.forEach(btn => {
    btn.setAttribute('aria-pressed', btn.dataset.range === state.range ? 'true' : 'false');

    btn.addEventListener('click', () => {
      if (searchInput) {
        searchInput.value = '';
        clearInputBtn?.classList.remove('is-visible');
      }

      state.q = '';
      state.range = btn.dataset.range;
      pageLimit = PAGE;

      filterBtns.forEach(b => b.setAttribute('aria-pressed','false'));
      btn.setAttribute('aria-pressed','true');

      if (azSelect) azSelect.value = state.range;

      suggestBox?.classList.remove('is-open');
      apply();
      updateReset();
    });
  });

  azSelect?.addEventListener('change', () => {
    if (searchInput) {
      searchInput.value = '';
      clearInputBtn?.classList.remove('is-visible');
    }

    state.q = '';
    state.range = azSelect.value || 'all';
    pageLimit = PAGE;

    filterBtns.forEach(b => {
      b.setAttribute('aria-pressed', b.dataset.range === state.range ? 'true' : 'false');
    });

    suggestBox?.classList.remove('is-open');
    apply();
    updateReset();
  });

  countrySel?.addEventListener('change', () => {
    state.country = norm(countrySel.value);
    state.province = '';
    pageLimit = PAGE;

    apply();
    updateReset();
  });

  provinceSel?.addEventListener('change', () => {
    state.province = norm(provinceSel.value);
    pageLimit = PAGE;

    apply();
    updateReset();
  });

  sortSel?.addEventListener('change', () => {
    state.sort = sortSel.value || 'default';
    pageLimit = PAGE;

    apply();
    updateReset();
  });

  const doReset = () => {
    state.q = '';
    state.range = 'all';
    state.country = '';
    state.province = '';
    state.sort = 'default';
    pageLimit = PAGE;

    if (searchInput) searchInput.value = '';
    clearInputBtn?.classList.remove('is-visible');

    filterBtns.forEach(b => {
      b.setAttribute('aria-pressed', b.dataset.range === 'all' ? 'true' : 'false');
    });

    if (azSelect) azSelect.value = 'all';
    if (countrySel) countrySel.value = '';
    if (provinceSel) {
      provinceSel.value = '';
      provinceSel.disabled = true;
    }
    if (sortSel) sortSel.value = 'default';

    suggestBox?.classList.remove('is-open');

    apply();
    updateReset();
  };

  clearBtn?.addEventListener('click', doReset);

  searchInput?.addEventListener('input', debounce(e => {
    state.q = norm(e.target.value || '');

    clearInputBtn?.classList.toggle('is-visible', !!state.q);

    if (state.q && state.range !== 'all') {
      state.range = 'all';

      filterBtns.forEach(b => {
        b.setAttribute('aria-pressed', b.dataset.range === 'all' ? 'true' : 'false');
      });

      if (azSelect) azSelect.value = 'all';
    }

    pageLimit = PAGE;

    apply();
    buildSuggest(state.q);
    updateReset();
  }, 220));

  clearInputBtn?.addEventListener('click', () => {
    if (!searchInput) return;

    searchInput.value = '';
    state.q = '';
    pageLimit = PAGE;

    clearInputBtn.classList.remove('is-visible');
    suggestBox?.classList.remove('is-open');

    apply();
    updateReset();
  });

  searchInput?.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      e.target.value = '';
      state.q = '';

      clearInputBtn?.classList.remove('is-visible');
      suggestBox?.classList.remove('is-open');

      apply();
      updateReset();

      return;
    }

    if (e.key === 'Enter') {
      const first = suggestBox?.querySelector('.wwc-sg-item');

      if (first) {
        location.assign(first.dataset.url);
        e.preventDefault();
      }
    }
  });

  document.addEventListener('click', e => {
    if (!suggestBox || !searchInput) return;

    const within = suggestBox.contains(e.target) || searchInput.contains(e.target);

    if (!within) suggestBox.classList.remove('is-open');
  });

  populateSelect(countrySel, sortCount(countBy(cards.map(c => c.country))), STR.ALL_COUNTRIES);

  if (countrySel) countrySel.value = state.country || '';
  if (sortSel) sortSel.value = state.sort || 'default';
  if (azSelect) azSelect.value = state.range || 'all';

  if (searchInput && state.q) {
    searchInput.value = state.q;
    clearInputBtn?.classList.toggle('is-visible', true);
  }

  apply();
  updateReset();

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 0);
})();